import { StoreData } from "./store.data";
import { CabinetFileType, VaultFileStatus } from "../types/cabinet.types";

export type VaultFileModelVersion = 3;
export interface VaultFileStoreModel extends StoreData {
  /**  **Version Number** **/
  v: VaultFileModelVersion;

  /** @alias **Encrypted Key** **/
  encK: encryptedKeyJSON;

  /** @alias **Name of the file** **/
  nm: string;

  /** @alias **Status of the file** **/
  stat: VaultFileStatus;

  /** @alias **mimeType of the file** **/
  mt: CabinetFileType;

  /** @alias **Statement to date** **/
  std: Date;

  /** @alias **Statement from date** **/
  sfd: Date;

  /** @alias **File size** **/
  fs: number;

  /** @alias **Statement Accounts' Id** **/
  sai: string[];

  /** @alias **Opening Balance** **/
  ob: number;

  /** @alias **Closing Balance** **/
  cb: number;
}

interface encryptedKeyJSON {
  keyB64: string;
}

export const DefaultVaultFileStoreModel: VaultFileStoreModel = {
  dc: "",
  dm: "",
  encK: undefined,
  id: "",
  mt: undefined,
  nm: "",
  sai: [],
  fs: 0,
  sfd: undefined,
  stat: undefined,
  std: undefined,
  v: 3,
  vid: "",
  ob: 0,
  cb: 0,
};
